import React from 'react';
import { Link, GatsbyLinkProps } from 'gatsby';
import classNames from 'classnames';

const NavLink: React.FC<Omit<GatsbyLinkProps<any>, 'ref'>> = ({ className, ...props }) => (
  <Link className={classNames('block py-4 lg:p-4 hover:text-cta', className)} {...props} />
);

export default NavLink;
